// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___GaZx_","title":"style__title___1jzub","subtitle":"style__subtitle___2OR47","or":"style__or___3CDeS","titleMemorial":"style__titleMemorial___3cJNm"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/screens/scan-method/style.css
// module id = 1093
// module chunks = 0